// import _ from "lodash";
// import { useEffect, useState, useRef } from "react";
// import ReactGA from "react-ga4";

// import classNames from "classnames";
// import styles from "./GPTModal.module.scss";

// // import { Modal } from "components";
// import { ModalItem } from "./ModalItem/ModalItem";
// // import { isAndroid } from "react-device-detect";
// import useRouter from "hooks/useRouter";
// import {
//   // ChatRoute,
//   IUploadFile
// } from "pages/ChatPage";

// import { ChatType, IChatModel, setChatModel } from "redux/actions";
// import { useSelector } from "redux/hooks";
// // import { useLocation } from 'react-router-dom';
// import { SearchField } from "views/layout/Sidebar/component/ChatSidebar/components/SearchField";
// import { FormattedMessage } from "react-intl";
// import { Spinner } from "components";
// import { FilterBadges } from "./FilterBadges/FilterBadges";

// interface IProps {
//   onClose?: () => void;
//   onStartNewChat?: ({ toChat }: { toChat: boolean }) => void;
//   isMainScreenOpen?: boolean;
//   isFileUploading?: boolean;
//   loadModel?: boolean;
//   uploadingFiles?: IUploadFile[];
// }

// export const GPTModal = ({ onClose,
//   // onStartNewChat,
//   // isMainScreenOpen,
//   // isFileUploading,
//   loadModel,
//   uploadingFiles,
// }: IProps) => {

//   const {
//     // includeRoute,
//     pathname } = useRouter();
//   // const location = useLocation();

//   const { chatContentUploadingFiles } = useSelector((state) => state.workSpaceReducer);
//   const { gptModel, theme } = useSelector((state) => state.authReducer);
//   const { chatModels } = useSelector((state) => state.chatModelsReducer);
//   const { newMessages, messages } = useSelector((state) => state.chatReducer);
//   const history = pathname.includes("/chat/history");
//   // const chatId = pathname.split("/")[3];

//   const inputRef = useRef<HTMLInputElement | null>(null);

//   const [tab, setTab] = useState<"text" | "image">("text");
//   const [searchQuery, setSearchQuery] = useState<string>('');
//   const [isPositionTop, setIsPositionTop] = useState<boolean>(true);

//   const [selectedModal, setSelectedModal] = useState<IChatModel>(
//     gptModel as IChatModel
//   );
//   const [filteredModels, setFilteredModel] = useState<IChatModel[]>([]);
//   const [filteredSearchModels, setFilteredSearchModel] = useState<IChatModel[]>([]);
//   const onSelectModal = (modal: IChatModel) => {
//     setSelectedModal(modal);
//     ReactGA.event({
//       action: "Popup_ModelSelection_Displayed",
//       category: "WebsiteModelSelectionPopUpShown",
//     });
//     setChatModel(modal);
//     if (gptModel?.type?.includes(ChatType.text)) {
//       localStorage.setItem('GptModel', JSON.stringify(modal));

//       const firstUploadingFileType = uploadingFiles?.[0]?.file.type ?? chatContentUploadingFiles?.[0]?.file.type;

//       const fileTypeToSet = firstUploadingFileType?.startsWith('image/')
//         ? 'imageChatGptModel'
//         : firstUploadingFileType?.startsWith('video/')
//           ? 'videoChatGptModel'
//           : firstUploadingFileType?.startsWith('audio/')
//             ? 'audioChatGptModel'
//             : firstUploadingFileType && !firstUploadingFileType.startsWith('image/')
//               ? 'documentChatGptModel'
//               : null;

//       if (fileTypeToSet) {
//         localStorage.setItem(fileTypeToSet, JSON.stringify(modal));
//       } else {
//         if (newMessages[0]?.chatType === 'image_chat' || (messages[0]?.chatType === 'image_chat' && history)) {
//           localStorage.setItem('imageChatGptModel', JSON.stringify(modal));
//         } else if (newMessages[0]?.chatType === 'document' || (messages[0]?.chatType === 'document' && history)) {
//           localStorage.setItem('documentChatGptModel', JSON.stringify(modal));
//         } else if (newMessages[0]?.chatType === 'video' || (messages[0]?.chatType === 'video' && history)) {
//           localStorage.setItem('videoChatGptModel', JSON.stringify(modal));
//         } else if (newMessages[0]?.chatType === 'audio' || (messages[0]?.chatType === 'audio' && history)) {
//           localStorage.setItem('audioChatGptModel', JSON.stringify(modal));
//         }
//       }
//     } else {
//       localStorage.setItem('imageGptModel', JSON.stringify(modal));
//     }
//     onClose?.();
//   }

//   useEffect(() => {
//     if (gptModel?.type?.includes(ChatType.image) && !gptModel?.type?.includes(ChatType.image_chat)) setTab("image");
//     else setTab("text");
//   }, [gptModel]);

//   useEffect(() => {
//     const newFilteredUserPrompts = filteredModels.filter((model) => {
//       return (model.name.toLowerCase().includes(searchQuery.toLowerCase()) && model?.type?.includes(tab) ||
//         model.name.includes(searchQuery) && model?.type?.includes(tab));
//     });
//     setFilteredSearchModel(newFilteredUserPrompts)
//   }, [searchQuery]);

//   useEffect(() => {
//     let filteredModels = chatModels;

//     // const shouldFilterByDocument =
//     //   ((messages[0]?.files || (messages[0]?.images && messages[0]?.images.length > 0)) || ((location.pathname === '/chat/new' )|| (location.pathname.startsWith('/workspaces') && chatContentUploadingFiles.length > 0)))&&
//     //   gptModel?.type?.includes(ChatType.text) &&
//     //   !_.isEqual(gptModel?.type, ["text"]) &&
//     //   (gptModel?.type?.includes(ChatType.text) || gptModel?.type?.includes(ChatType.document))

//     // if (shouldFilterByDocument) {
//     //   if (newMessages.length > 0 && !newMessages[0]?.files && (newMessages[0]?.images && newMessages[0]?.images.length === 0) && ((((uploadingFiles && uploadingFiles.length === 0) || (chatContentUploadingFiles && chatContentUploadingFiles.length === 0)))) && !isFileUploading)
//     //     filteredModels = chatModels;
//     //   else if ((isMainScreenOpen && !newMessages[0]?.files && !includeRoute(ChatRoute.History) && (uploadingFiles === null || uploadingFiles?.length === 0) && !isFileUploading))
//     //     filteredModels = chatModels;
//     //   else if ((((uploadingFiles && uploadingFiles[0]?.file.type.includes('image/')) || (chatContentUploadingFiles && chatContentUploadingFiles[0]?.file.type.includes('image/')))|| ((newMessages[0]?.images && newMessages[0]?.images.length > 0) || (messages[0]?.images && messages[0]?.images.length > 0 && messages[0]?.chat_id === Number(chatId)))))
//     //     filteredModels = chatModels.filter(model => model.type.includes(ChatType.image_chat) && model.type.includes('document'));
//     //   else if ((((uploadingFiles && uploadingFiles[0]?.file.type.includes('video/')) || (chatContentUploadingFiles && chatContentUploadingFiles[0]?.file.type.includes('video/'))) || ((newMessages[0]?.chatType === "video") || (messages[0]?.chatType === "video" && messages[0]?.chat_id === Number(chatId)))))
//     //     filteredModels = chatModels.filter(model => model.type.includes(ChatType.video));
//     //   else if ((((uploadingFiles && uploadingFiles[0]?.file.type.includes('audio/')) || (chatContentUploadingFiles && chatContentUploadingFiles[0]?.file.type.includes('audio/'))) || ((newMessages[0]?.chatType === "audio") || (messages[0]?.chatType === "audio" && messages[0]?.chat_id === Number(chatId)))))
//     //     filteredModels = chatModels.filter(model => model.type.includes(ChatType.audio));
//     //   else
//     //     filteredModels = chatModels.filter(model => model.type.includes('document'));
//     // }
//     setFilteredModel(filteredModels);

//   }, [chatModels, searchQuery === '',]);

//   const onClearSearchField = () => {
//     setSearchQuery("");
//     if (inputRef.current) {
//       inputRef.current.focus();
//       setIsPositionTop(true);
//     }

//   };

//   const handleSerchFocus = () => {
//     if (inputRef.current) {
//       inputRef.current.focus();
//       setIsPositionTop(true);
//     }
//   }

//   return (
//     // <Modal size="xs" positionTop={isAndroid ? isPositionTop : false} onClose={onClose} GPTModel={true}>
//     <div className="flex flex-col gap-[24px]">
//       <div
//       // className="px-[30px] pt-[7px]"
//       >
//         <SearchField
//           inputRef={inputRef}
//           value={searchQuery}
//           gptModal={true}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           onClear={onClearSearchField}
//           setIsPositionTop={setIsPositionTop}
//           isPositionTop={isPositionTop}
//           handleSerchFocus={handleSerchFocus}
//           autoFocus
//         />
//       </div>
//       <div>
//         <FilterBadges />
//         <div className={classNames(styles.body, {
//           [styles.light]: theme === 'light',
//           [styles.dark]: theme === 'dark',
//         })}>
//           {chatModels.length > 0 ? (
//             searchQuery !== '' && filteredSearchModels.length > 0 ?
//               filteredSearchModels.filter((model) => model?.type?.includes(tab))
//                 .map((model) => (
//                   <ModalItem
//                     chatModel={model}
//                     selectedModal={selectedModal}
//                     onSelectModal={onSelectModal}
//                   />
//                 ))
//               : searchQuery !== '' && filteredSearchModels.length === 0 ? (
//                 <div className={classNames(styles.message, {
//                   [styles.light]: theme === 'light',
//                 })}><FormattedMessage id="gptmodel.no.available" /></div>
//               ) :
//                 filteredModels
//                   .filter((model) => model?.type?.includes(tab))
//                   .map((model) => (
//                     <ModalItem
//                       chatModel={model}
//                       selectedModal={selectedModal}
//                       onSelectModal={onSelectModal}
//                     />
//                   ))
//           ) : (
//             loadModel ? (
//               <div className='flex item-centers justify-center mb-2'>
//                 <Spinner small />
//               </div>
//             ) : (
//               <div className={classNames(styles.message, {
//                 [styles.light]: theme === 'light',
//               })}><FormattedMessage id="gptmodel.no.available" /></div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//     // </Modal>
//   );
// };

import _ from "lodash";
import { useEffect, useState, useRef } from "react";
import ReactGA from "react-ga4";

import classNames from "classnames";
import styles from "./GPTModal.module.scss";

import { ModalItem } from "./ModalItem/ModalItem";
import useRouter from "hooks/useRouter";
import { IUploadFile } from "pages/ChatPage";

import { ChatType, IChatModel, setChatModel } from "redux/actions";
import { useSelector } from "redux/hooks";
import { SearchField } from "views/layout/Sidebar/component/ChatSidebar/components/SearchField";
import { FormattedMessage } from "react-intl";
import { Spinner } from "components";
import { FilterBadges } from "./FilterBadges/FilterBadges";
import { NoModelFound } from "./FilterBadges/NoModelFound";
import { RequestModel } from "./FilterBadges/RequestModel";

interface IProps {
  onClose?: () => void;
  onStartNewChat?: ({ toChat }: { toChat: boolean }) => void;
  isMainScreenOpen?: boolean;
  isFileUploading?: boolean;
  loadModel?: boolean;
  uploadingFiles?: IUploadFile[];
  webSearch?: boolean;
}

export const GPTModal = ({
  onClose,
  loadModel,
  uploadingFiles,
  webSearch,
}: IProps) => {
  const { pathname } = useRouter();

  const { chatContentUploadingFiles } = useSelector(
    (state) => state.workSpaceReducer
  );
  const { gptModel, theme } = useSelector((state) => state.authReducer);
  const { chatModels } = useSelector((state) => state.chatModelsReducer);
  const { newMessages, messages } = useSelector((state) => state.chatReducer);
  const history = pathname.includes("/chat/history");

  const inputRef = useRef<HTMLInputElement | null>(null);

  const [tab, setTab] = useState<"text" | "image">("text");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isPositionTop, setIsPositionTop] = useState<boolean>(true);
  const [activeFilter, setActiveFilter] = useState<string>("");
  const [topMultiModels, setTopMultiModels] = useState<IChatModel[]>([]);

  const [selectedModal, setSelectedModal] = useState<IChatModel>(
    gptModel as IChatModel
  );
  const [filteredModels, setFilteredModel] = useState<IChatModel[]>([]);
  const [filteredSearchModels, setFilteredSearchModel] = useState<IChatModel[]>(
    []
  );

  const onSelectModal = (modal: IChatModel) => {
    setSelectedModal(modal);
    ReactGA.event({
      action: "Popup_ModelSelection_Displayed",
      category: "WebsiteModelSelectionPopUpShown",
    });
    setChatModel(modal);
    if (gptModel?.type?.includes(ChatType.text)) {
      localStorage.setItem("GptModel", JSON.stringify(modal));

      const firstUploadingFileType =
        uploadingFiles?.[0]?.file.type ??
        chatContentUploadingFiles?.[0]?.file.type;

      const fileTypeToSet = firstUploadingFileType?.startsWith("image/")
        ? "imageChatGptModel"
        : firstUploadingFileType?.startsWith("video/")
          ? "videoChatGptModel"
          : firstUploadingFileType?.startsWith("audio/")
            ? "audioChatGptModel"
            : firstUploadingFileType &&
                !firstUploadingFileType.startsWith("image/")
              ? "documentChatGptModel"
              : null;

      if (fileTypeToSet) {
        localStorage.setItem(fileTypeToSet, JSON.stringify(modal));
      } else {
        if (
          newMessages[0]?.chatType === "image_chat" ||
          (messages[0]?.chatType === "image_chat" && history)
        ) {
          localStorage.setItem("imageChatGptModel", JSON.stringify(modal));
        } else if (
          newMessages[0]?.chatType === "document" ||
          (messages[0]?.chatType === "document" && history)
        ) {
          localStorage.setItem("documentChatGptModel", JSON.stringify(modal));
        } else if (
          newMessages[0]?.chatType === "video" ||
          (messages[0]?.chatType === "video" && history)
        ) {
          localStorage.setItem("videoChatGptModel", JSON.stringify(modal));
        } else if (
          newMessages[0]?.chatType === "audio" ||
          (messages[0]?.chatType === "audio" && history)
        ) {
          localStorage.setItem("audioChatGptModel", JSON.stringify(modal));
        }
      }
    } else {
      localStorage.setItem("imageGptModel", JSON.stringify(modal));
    }
    onClose?.();
  };

  useEffect(() => {
    if (
      gptModel?.type?.includes(ChatType.image) &&
      !gptModel?.type?.includes(ChatType.image_chat)
    )
      setTab("image");
    else setTab("text");
  }, [gptModel]);

  // useEffect(() => {
  //   const newFilteredUserPrompts = filteredModels.filter((model) => {
  //     return (model.name.toLowerCase().includes(searchQuery.toLowerCase()) && model?.type?.includes(tab) ||
  //       model.name.includes(searchQuery) && model?.type?.includes(tab));
  //   });
  //   setFilteredSearchModel(newFilteredUserPrompts)
  // }, [searchQuery]);

  useEffect(() => {
    // Enhanced search functionality to include supported_downstream_tasks
    const newFilteredUserPrompts = filteredModels.filter((model) => {
      const matchesTab = model?.type?.includes(tab);

      if (!matchesTab || !searchQuery) {
        return matchesTab;
      }

      const lowerSearchQuery = searchQuery.toLowerCase();

      // Search in model name
      const nameMatch = model.name.toLowerCase().includes(lowerSearchQuery);

      // Search in supported_downstream_tasks
      const taskMatch =
        model.attributes &&
        model.attributes.supported_downstream_tasks &&
        model.attributes.supported_downstream_tasks
          .toLowerCase()
          .includes(lowerSearchQuery);

      // Search in released_by
      const releasedByMatch =
        model.attributes &&
        model.attributes.released_by &&
        model.attributes.released_by.toLowerCase().includes(lowerSearchQuery);

      // Return true if any of the fields match
      return nameMatch || taskMatch || releasedByMatch;
    });

    setFilteredSearchModel(newFilteredUserPrompts);
  }, [searchQuery]);

  useEffect(() => {
    let modelsToFilter = chatModels;
    // Apply badge filter if active
    if (activeFilter) {
      switch (activeFilter) {
        case "multi":
          // Filter models with more than one type
          modelsToFilter = modelsToFilter.filter(({ attributes }) => {
            const modalities = attributes?.supported_modalities
              ?.split(",")
              .map((m) => m.trim())
              .filter(Boolean);
            return modalities && modalities.length > 1;
          });
          break;
        case "text":
          // Filter models with text type
          modelsToFilter = modelsToFilter.filter(
            (model) => model.type && model.type.includes(ChatType.text)
          );
          break;
        case "image":
          // Filter models with image type
          modelsToFilter = modelsToFilter.filter(
            (model) =>
              model.type &&
              (model.type.includes(ChatType.image) ||
                model.type.includes(ChatType.image_chat))
          );
          break;
        case "websearch":
          // Filter models where provider is Perplexity
          modelsToFilter = modelsToFilter.filter((model) => {
            const modalities = model.attributes?.supported_modalities
              ?.split(",")
              .map((m) => m.trim().toLowerCase());
            return modalities?.includes("web-search");
          });
          break;
        default:
          break;
      }
    }

    setFilteredModel(modelsToFilter);
  }, [chatModels, activeFilter]);

  useEffect(() => {
    if (chatModels.length > 0) {
      let multiModels = [];

      if (selectedModal.type.includes("image")) {
        multiModels = chatModels.filter((model) =>
          model.type.includes("image")
        );
      } else {
        multiModels = chatModels.filter(
          (model) => !model.type.includes("image")
        );
      }

      setTopMultiModels(multiModels.slice(0, 3));
    }
  }, [chatModels]);

  const onClearSearchField = () => {
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.focus();
      setIsPositionTop(true);
    }
  };

  const handleSerchFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setIsPositionTop(true);
    }
  };

  const handleFilterChange = (filterType: string) => {
    setActiveFilter(filterType);
  };

  return (
    <div className="flex flex-col gap-[24px]">
      <div>
        <SearchField
          inputRef={inputRef}
          value={searchQuery}
          gptModal={true}
          onChange={(e) => setSearchQuery(e.target.value)}
          onClear={onClearSearchField}
          setIsPositionTop={setIsPositionTop}
          isPositionTop={isPositionTop}
          handleSerchFocus={handleSerchFocus}
          autoFocus
        />
      </div>
      <div>
        <FilterBadges
          webSearch={webSearch}
          onFilterChange={handleFilterChange}
        />
        <div
          className={classNames(styles.body, {
            [styles.light]: theme === "light",
            [styles.dark]: theme === "dark",
          })}
        >
          {chatModels.length > 0 ? (
            searchQuery !== "" && filteredSearchModels.length > 0 ? (
              filteredSearchModels
                .filter((model) => model?.type?.includes(tab))
                .map((model, index) => (
                  <ModalItem
                    key={index}
                    chatModel={model}
                    selectedModel={selectedModal}
                    onSelectModal={onSelectModal}
                  />
                ))
            ) : searchQuery !== "" && filteredSearchModels.length === 0 ? (
              <div
                className={classNames(styles.message, {
                  [styles.light]: theme === "light",
                })}
              >
                <div className="flex flex-col gap-[24px]">
                  <NoModelFound />
                  {topMultiModels.length > 0 && (
                    <div>
                      <h3 className="text-[#171717] dark:text-[#fff] text-[16px] font-medium mb-3 font-inter">
                        <FormattedMessage id="gptmodel.alternatives" />
                      </h3>
                      <div className="flex flex-col gap-4 ">
                        {topMultiModels.map((model, index) => (
                          <ModalItem
                            key={index}
                            chatModel={model}
                            selectedModel={selectedModal}
                            onSelectModal={onSelectModal}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  <RequestModel />
                </div>
              </div>
            ) : (
              filteredModels
                .filter((model) => model?.type?.includes(tab))
                .map((model, index) => (
                  <ModalItem
                    key={index}
                    chatModel={model}
                    selectedModel={selectedModal}
                    onSelectModal={onSelectModal}
                  />
                ))
            )
          ) : loadModel ? (
            <div className="flex item-centers justify-center mb-2">
              <Spinner small />
            </div>
          ) : (
            <div
              className={classNames(styles.message, {
                [styles.light]: theme === "light",
              })}
            >
              <FormattedMessage id="gptmodel.no.available" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
